// extracted by mini-css-extract-plugin
export default {"background":"cover_background__HUk2n","img":"cover_img__w3VWI"};